import { Plus } from 'lucide-react';
import { PageSection } from '@/components/common/PageSection';
import { SectionHeading } from '@/components/common/SectionHeading';
import { Faq } from '@/pages/Home/data';

const SectionId = 'faq';
const TitleId = 'faq-title';

export function FaqSection() {
  return (
    <PageSection id={SectionId} titleId={TitleId}>
      <div className="grid gap-10 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-4">
          <SectionHeading id={TitleId} title={Faq.title} description={Faq.description} />
        </div>
        <div className="border-t border-grid lg:col-span-8">
          {Faq.items.map((faqItem) => (
            <details key={faqItem.question} className="group border-b border-grid">
              <summary className="flex cursor-pointer list-none items-start justify-between gap-6 rounded-sm py-5 text-lg font-semibold text-graphite focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-graphite [&::-webkit-details-marker]:hidden">
                <span>{faqItem.question}</span>
                <Plus aria-hidden="true" className="mt-1 size-5 shrink-0 text-steel transition-transform duration-200 group-open:rotate-45" />
              </summary>
              <p className="max-w-[65ch] pb-6 leading-relaxed text-steel">{faqItem.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </PageSection>
  );
}